import { useSyncExternalStore } from 'react';

/**
 * "Tem partida acontecendo agora?"
 *
 * Existe por um motivo só: o aviso de atualização precisa saber disso. Com
 * partida aberta ele muda de tom — de "Atualizar" para "Atualize ao final da
 * partida" — porque recarregar o /controle no meio de um sorteio é o pior
 * momento possível, e o aviso não deveria convidar a isso.
 *
 * Quem publica é o /controle (a única tela que sabe). Quem lê é o aviso, que
 * é global. Um store minúsculo em vez de contexto: o aviso vive fora da
 * árvore do /controle.
 */

type Listener = () => void;

const listeners = new Set<Listener>();
let live = false;

export function setGameLive(value: boolean): void {
  if (live === value) return;
  live = value;
  for (const listener of listeners) listener();
}

export function gameLiveSnapshot(): boolean {
  return live;
}

export function subscribeGameLive(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * O valor é um booleano, então publicar "a mesma referência" não é problema
 * aqui — `Object.is(false, false)` é verdadeiro e o React simplesmente não
 * re-renderiza, que é o certo quando nada mudou. (A armadilha dos snapshots
 * mutáveis vale para objetos; ver `session.ts`.)
 */
export function useGameLive(): boolean {
  return useSyncExternalStore(subscribeGameLive, gameLiveSnapshot, gameLiveSnapshot);
}
